<template>
  <v-card class="news-source my-3" elevation="0" outlined>
    <div class="handler">
      <slot></slot>
    </div>
    <div class="subtitle-2">{{ link_title }}</div>
    <div class="body-2">{{ link_description }}</div>
    <div class="body-2 text-muted">{{ date }}</div>
    <div class="buttons">
      <v-btn small @click="onClickDelete" text :loading="deleting">Radera</v-btn>
      <v-btn small color="primary" @click="$emit('edit', id)" text>Ändra</v-btn>
      <v-btn small color="primary" :href="link_url" target="_blank" text>Öppna länk</v-btn>
    </div>
  </v-card>
</template>

<script>
/* eslint camelcase: 0 */
import moment from 'moment'

export default {
  name: 'NewsSource',
  props: {
    id: { type: Number },
    link_description: { type: String },
    link_title: { type: String },
    link_url: { type: String },
    link_date_created: { type: String },
  },
  data() {
    return {
      deleting: false,
    }
  },
  computed: {
    date() {
      return moment(this.link_date_created).format('YYYY-MM-DD')
    },
  },
  methods: {
    onClickDelete() {
      this.deleting = true
      this.$emit('delete', this.link_url)
    },
  },
}
</script>

<style lang="less" scoped>
.news-source {
  position: relative;
  padding: 7px;
  border-radius: 4px;
  display: flex;
  flex-direction: column;
  gap: 5px;
  .description {
  }
  .buttons {
    display: flex;
    gap: 15px;
    justify-content: flex-end;
  }
}
.handler {
  position: absolute;
  right: 0;
  cursor: grab;
}
.text-muted {
  color: #6c757d;
}
</style>
